import React from 'react';

export default function SelectGuide({ guides = [], value, guideSelected }) {
    const availableGuides = Array.isArray(guides) ? guides : [];

    function handleGuideChange(event) {
        const selectedGuideId = event.target.value;
        const selectedGuide = availableGuides.find((guide) => guide.id.toString() === selectedGuideId.toString());

        if (!selectedGuide) {
            return;
        }

        guideSelected(selectedGuide);
    }

    const options = availableGuides.map((guide) => (
        <option value={guide.id} key={guide.id}>
            {guide.name}
        </option>
    ));

    return (
        <select id="guide" value={value?.id ?? ''} onChange={handleGuideChange}>
            <option value="">Select a guide</option>
            {options}
        </select>
    );
}
